<!-- 产品管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexJc-sb flexAi-c  pad">
        <div class="text">产品列表</div>
        <el-button @click="addShopBut" round type="primary" size="mini"
          >添加产品</el-button
        >
      </div>
      <div class="content">
        <el-table
          height="68vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="CategoryList.list"
          style="width: 100%"
        >
          <el-table-column prop="cateId" label="#" width="80"></el-table-column>
          <el-table-column prop="parentid" label="PID" width="80"></el-table-column>
          <el-table-column prop="cateName" label="产品"> </el-table-column>
          <el-table-column label="产品图片" class="certificateImg">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.catePic === ''"
                style="width: 100px; height: 100px"
                src="/"
              >
              </el-image>
              <el-image
                v-else
                style="width: 60px; height: 60px"
                :src="baseImage + scope.row.catePic"
                :preview-src-list="[baseImage + scope.row.catePic]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="产品介绍" width="150">
            <template slot-scope="scope">
              <div class="introduce">
                {{ scope.row.cateDesc | getText }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="catePrice" label="价格"> </el-table-column>
          <el-table-column prop="cateNewprice" label="新用户价格" width="130">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.adActivate | filterNum('停用', '激活') }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >修改</el-link
              >
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex" v-if="CategoryList !== ''">
          <div class="text">
            <span>共{{ CategoryList.total }}条记录，</span>
            <span class="pageNum">{{ CategoryList.pageNum }}</span>
            <span>/{{ CategoryList.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="CategoryList.pageNum"
            :page-size="CategoryList.pageSize"
            layout="prev, pager, next, jumper"
            :total="CategoryList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetCategoryList, apiDelCategory } from '@/api/ProductManage'

export default {
  name: '',
  props: [''],
  data() {
    return {
      CategoryList: '',
      pages: {
        pageNum: 1,
        pageSize: 20
      } // 页数
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetCategoryList()
  },

  methods: {
    // 添加产品
    addShopBut() {
      this.$router.push({
        path: '/AddProduct'
      })
    },
    // 列表删除
    delBut(row) {
      console.log(row)
      apiDelCategory({
        cateId: row.cateId
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetCategoryList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 列表修改
    editBut(row) {
      this.$router.push({
        path: '/AddProduct',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.pageNum = val
      console.log(`当前页: ${val}`)
      this.GetCategoryList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 产品列表
    GetCategoryList() {
      apiGetCategoryList({
        page: this.pages.pageNum,
        pageSize: this.pages.pageSize
      }).then(res => {
        if (res.status === 0) {
          this.CategoryList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      color: #119685;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 产品介绍
    /deep/ .introduce {
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 3 !important;
      overflow: hidden !important;
      color: #9e9e9e;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    // 分页
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
